import React from 'react';
import { Link, NavLink, Redirect } from 'react-router-dom';
import { JS_RELEASE_VERSION } from "../../helpers/Constants";
import AuthService from "../../services/AuthService";
import MembersApi from "../../services/portal-api/MembersApi";

export default class Header extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            storeName: '',
            suburb: '',
            stores: [],
            storeId: '',
            shouldRedirect: false,
        }
    }

    componentDidMount() {
        if (!this.props.isLoggedOut) {
            if (this.state.storeName == '') {
                this.fetchstoreDetailsAndStores();
            }
        }
    }

    fetchstoreDetailsAndStores() {
        MembersApi.fetchstoreDetailsAndStores((result) => {
            if (result.success) {
                if (result.json.storeDetails != null) {
                    sessionStorage.setItem("store-name", result.json.storeDetails.name);
                }

                this.setState({
                    'storeName': (result.json.storeDetails != null) ? result.json.storeDetails.name : '',
                    'suburb': (result.json.storeDetails != null) ? result.json.storeDetails.suburb : '',
                    'stores': result.json.userDetails,
                    'storeId': (result.json.storeDetails != null) ? result.json.storeDetails.id : ''
                }, () => {
                    console.log('set state');
                });
            }
        }, AuthService.getUserId());
    }

    // handleChange = (event) => {
    //     if (window.confirm("Are you sure you want to change the store?")) {
    //         const value = event.target.value;
    //         const sendParams = {
    //             storeId: value,
    //             userId: AuthService.getUserId()
    //         };

    //         MembersApi.setStoreAndRole(sendParams, (response) => {
    //             if (response.success) {
    //                 AuthService.setLocalStorageStoreId(value);
    //                 AuthService.setLocalStorageRoleId(response.json.isAdmin);

    //                 this.setState({
    //                     storeId: value,
    //                     shouldRedirect: true
    //                 }, () => {
    //                     this.fetchstoreDetailsAndStores();
    //                 });

    //             } else {
    //                 response.status === 401 ? alert("Something went wrong") : console.log(response);
    //             }
    //         });
    //     }
    // };

    render() {
        if (this.state.shouldRedirect) {
            if (window.location.pathname != "/") {
                return <Redirect to="/" />;
            }
        }

        let versionName = 'duskPortal Version ' + JS_RELEASE_VERSION;
        if (JS_RELEASE_VERSION !== window.REQUIRED_RELEASE_VERSION) {
            versionName += ' (Update available! Clear cache.)';
        }
        let UserTop = { top: 42 };
        if ((this.state.storeName || "").toLowerCase() != (AuthService.getName() || "").toLowerCase()) {
            UserTop = { top: 15 };
        }
        const isStaging = (window.location.host === 'staging-portal.dusk.com.au' || window.location.host === 'staging-portal.duskcandles.co.nz');
        const siteIn = sessionStorage.getItem('site') == 'NZ' ? 'New Zealand' : 'Australia';
        let userpath = AuthService.getAdminType() == 4 ? "/new-users" : "/new-store/" + AuthService.getFuturaStoreId() + "/edit/" + this.state.suburb;

        // console.log("admin type", AuthService.getAdminType());
        // console.log("isAdmin", AuthService.isAdmin());

        // const storesOption = this.state.stores.map(store => {
        //     return (
        //         <option value={store.storeId} key={store.storeId}>{store.storeName}</option>
        //     )
        // })

        return (
            <div>
                <h1 className="u-vis-hide">duskPortal</h1>

                {isStaging && <div className="header--bar text--center text--bold text--12 text--caps text--white padding--10">Staging portal</div>}
                <header className="header--main" role="banner">

                    <Link to="/" className="logo" title={versionName} style={{ top: 43 }}>
                        <img src="/img/logo.svg" alt="duskPortal" />
                        <span style={{ color: '#cfcece', top: -9, left: siteIn == 'Australia' ? 18 : 0, position: 'relative', fontSize: 18, fontWeight: 700, fontStyle: 'italic', fontSize: 'medium' }} >{siteIn}</span>
                    </Link>

                    {this.props.isLoggedOut && !this.props.isReset && <Link to="/login" className="header--main__login text--40">Login</Link>}

                    {this.props.isReset && <Link to={this.props.rtype == "in" ? "/reset/in" : "/reset/forgot"} className="header--main__login text--40">Reset Password</Link>}

                    {!this.props.isLoggedOut && this.props.isReset && <div className="header--main__signin" style={UserTop}>
                        {AuthService.getAdminType() == 1 && <strong>Super Admin:</strong>}
                        {AuthService.getAdminType() == 2 && <strong>Store Admin:</strong>}
                        {AuthService.getAdminType() == 3 && <strong>Customer Support Admin:</strong>}
                        {AuthService.getAdminType() == 0 && <strong>Store User:</strong>}
                        {AuthService.getAdminType() == 4 && <strong>Area Manager:</strong>}
                        <span className="header--main__signin__name">{AuthService.getName()}</span>
                        {!this.props.isLoggedOut && this.props.isReset && (this.state.storeName || "").toLowerCase() != (AuthService.getName() || "").toLowerCase() && <div>
                            <strong>Store:</strong>
                            <span className="header--main__signin__name">{this.state.storeName}</span>
                        </div>}
                    </div>}

                    {!this.props.isLoggedOut && this.props.isReset && <Link to="/logout" className="header--main__logout text--caps">
                        <img src="/img/icon-logout--red.svg" alt="" className="icon" />
                        Logout
                    </Link>}

                    {!this.props.isLoggedOut && !this.props.isReset &&
                        <ul className="header--nav">
                            {AuthService.can('Home') &&
                                <li>
                                    <NavLink exact to="/" activeClassName="active">
                                        <div className="icon-wrap">
                                            <img src="/img/icon-home--yellow.svg" alt="" width="37" height="30" className="icon icon--home" />
                                        </div>
                                        <span className="header--nav__text">Home</span>
                                    </NavLink>
                                </li>
                            }
                            {AuthService.can('Gift card lookup') &&
                                <li>
                                    <NavLink to="/giftcards" activeClassName="active">
                                        <div className="icon-wrap">
                                            <img src="/img/icon-gclookup--purple.svg" alt="" width="41" height="32" className="icon icon--giftcard" />
                                        </div>
                                        <span className="header--nav__text">Gift Card Lookup</span>
                                    </NavLink>
                                </li>
                            }
                            {AuthService.can('member lookup') &&
                                <li>
                                    <NavLink to="/members">
                                        <div className="icon-wrap">
                                            <img src="/img/icon-memberlookup--blue.svg" alt="" width="36" height="36" className="icon icon--memberlookup" />
                                        </div>
                                        <span className="header--nav__text">Member Lookup</span>
                                    </NavLink>
                                </li>
                            }
                            {AuthService.can('Create member') &&
                                <li>
                                    <NavLink exact to="/new-member">
                                        <div className="icon-wrap">
                                            <img src="/img/icon-newmember--green.svg" alt="" width="34" height="35" className="icon icon--newmember" />
                                        </div>
                                        <span className="header--nav__text">Create Member</span>
                                    </NavLink>
                                </li>
                            }
                            {AuthService.can('store users') &&
                                <li>
                                    <NavLink exact to={userpath}>
                                        <div className="icon-wrap">
                                            <img src="/img/icon-admin--yellow.svg" alt="" width="34" height="35" className="icon icon--newmember" />
                                        </div>
                                        <span className="header--nav__text">Store Users</span>
                                    </NavLink>
                                </li>
                            }
                        </ul>
                    }



                    {!this.props.isLoggedOut &&
                        <div className="header--main__signin" style={UserTop}>
                            {AuthService.getAdminType() == 1 && <strong>Super Admin:</strong>}
                            {AuthService.getAdminType() == 2 && <strong>Store Admin:</strong>}
                            {AuthService.getAdminType() == 3 && <strong>Customer Support Admin:</strong>}
                            {AuthService.getAdminType() == 0 && <strong>Store User:</strong>}
                            {AuthService.getAdminType() == 4 && <strong>Area Manager:</strong>}
                            <span className="header--main__signin__name">{AuthService.getName()}</span>
                            {!this.props.isLoggedOut && (this.state.storeName || "").toLowerCase() != (AuthService.getName() || "").toLowerCase() &&
                                <div>
                                    <strong>Store:</strong>
                                    {/* {AuthService.getAdminType() != 1 && <span className="header--main__signin__name">
                                        <select
                                            name="storeSelect"
                                            style={{ color: 'white', backgroundColor: 'black' }}
                                            value={this.state.storeId}
                                            onChange={this.handleChange}
                                        >
                                            {storesOption}
                                        </select>
                                    </span>}
                                    {AuthService.getAdminType() == 1 && <span className="header--main__signin__name">{this.state.storeName}</span>} */}
                                    <span className="header--main__signin__name">{this.state.storeName}</span>
                                </div>
                            }
                        </div>
                    }

                    {!this.props.isLoggedOut && <Link to="/logout" className="header--main__logout text--caps">
                        <img src="/img/icon-logout--red.svg" alt="" className="icon" />
                        Logout
                    </Link>}

                </header>
                {/* {!this.props.isLoggedOut && AuthService.isAdmin() && */}
                {!this.props.isLoggedOut && AuthService.can('admin tools') &&
                    <NavLink exact to="/admintools">
                        <div style={{ width: 29, height: 30, position: "fixed", zIndex: 99999, top: 150, boxShadow: '1px 1px 11px #bccc', borderBottomRightRadius: 14, borderTopRightRadius: 14, cursor: "pointer" }} title="Admin Tools"><img src="/img/Gear-px.gif" style={{ width: 30, width: 30 }} ></img></div>
                    </NavLink>
                }
            </div>
        )
    }
}
